module.exports = __webpack_public_path__ + "img/ico_btn_next.dfe32364.svg";